module.exports = __webpack_public_path__ + "static/media/nike-like-a-lioness.78348882.mp4";